import { getDexConfig } from "@/utils/get-dex-config";
import { assetUrl } from '@/utils/asset-url';
import { getEnvAndDex } from "@/utils/get-env-and-dex";
import PropTypes from "prop-types";
import Icon from "@/componentsDS/Icon/Icon";

const MyinfoBusinessCard = ({ onMyinfoBusinessClick, isFilledWithMyInfo, clearForm }) => {

	const { dex } = getEnvAndDex();
	const { dexName } = getDexConfig(dex);


	return (
		<div className="myinfo-business__card_container">
			{!isFilledWithMyInfo ? (
				<>
					<div className="myinfo-business__card_title">
						Faster form filling with MyInfo business
					</div>
					<p className="myinfo-business__card_info">
						{`Myinfo business retrieves personal and corporate data from
				relevant government agencies to pre-fill the relevant fields,
				making digital transactions faster and more convenient. This
				digital service, ${dexName}, by Dex is requesting the following
				information from Myinfo business, for the purpose of ${dexName}
				account registration.`}
					</p>
					<div>
						<button onClick={onMyinfoBusinessClick}>
							<img
								className="myinfo-business__card_img"
								src={assetUrl("/singpass.png")}
								alt="singpass"
							/>
						</button>
					</div>
				</>
			) : (
				<div className="myinfo-business__feedback-container">
					<div className="DS_icon DS__icon--fill">
						<Icon
							name="information-circle"
							style="outlined"
							size="large"
						/>
					</div>
					<p>Filled with Myinfo business.</p>
					<p onClick={clearForm} role="none">Fill Manually Instead</p>
				</div>
			)}
		</div>
	);
};

export default MyinfoBusinessCard;

MyinfoBusinessCard.propTypes = {
	onMyinfoBusinessClick: PropTypes.func,
	isFilledWithMyInfo: PropTypes.bool,
	clearForm: PropTypes.func
};
